document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.custom-logoes');
  if (!section) return;

  const track = section.querySelector('.grid--slider');
  if (!track) return;

  const items = Array.from(track.children);

  // Clone once for infinite loop
  items.forEach(item => {
    const clone = item.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  let position = 0;
  const speed = 0.8;

  function animate() {
    position -= speed;

    const resetPoint = track.scrollWidth / 2;
    if (Math.abs(position) >= resetPoint) {
      position = 0;
    }

    track.style.transform = `translate3d(${position}px, 0, 0)`;
    requestAnimationFrame(animate);
  }

  animate();
});


// youtube video app
(function () {
  const fixSlider = () => {
    const swiperEl = document.querySelector('.reputon-swiper');
    if (!swiperEl || !swiperEl.swiper) return;

    const swiper = swiperEl.swiper;
    const isMobile = window.innerWidth <= 767;

    // Responsive settings
    swiper.params.slidesPerView = isMobile ? 1 : 3;
    swiper.params.centeredSlides = false;
    swiper.params.spaceBetween = isMobile ? 12 : 20;
    swiper.params.slidesOffsetBefore = 0;
    swiper.params.slidesOffsetAfter = 0;

    swiper.update();

    // Prevent left cut-off issue
    swiper.slideTo(0, 0);
  };

  // Watch if the app tries to reinitialize/reset Swiper
  const observer = new MutationObserver(fixSlider);
  const target = document.querySelector('.reputon-swiper');

  if (target) {
    observer.observe(target, { attributes: true, childList: true, subtree: true });
  }

  window.addEventListener('load', () => {
    setTimeout(fixSlider, 1000);
  });

  window.addEventListener('resize', fixSlider);
})();

// home slider video load image 

document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('.video-el');
  const poster = document.querySelector('.video-poster');

  if (!video || !poster) return;

  video.addEventListener('canplay', () => {
    video.style.opacity = '1';
    poster.style.opacity = '0';
    poster.style.transition = 'opacity 0.4s ease';
    setTimeout(() => poster.remove(), 400);
  });
});



(function() {
    const fixSwiper = () => {
        // Target the container using the class from your HTML
        const container = document.querySelector('.swiper.swiper-initialized');
        
        if (container && container.swiper) {
            const instance = container.swiper;

            if (window.innerWidth >= 1024) {
                // 1. Force internal parameters
                instance.params.slidesPerView = 3;
                instance.params.slidesPerGroup = 1;
                instance.params.centeredSlides = false; // Ensures they align left-to-right
                
                // 2. Update the layout
                instance.update();
                
                // 3. Optional: Re-calculate if the widget tries to revert
                instance.on('resize', () => {
                    if (window.innerWidth >= 1024) {
                        instance.params.slidesPerView = 3;
                        instance.update();
                    }
                });
            }
        }
    };

    // Fix the "Node" error by ensuring the DOM is fully interactive
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        fixSwiper();
        setupObserver();
    } else {
        window.addEventListener('DOMContentLoaded', () => {
            fixSwiper();
            setupObserver();
        });
    }

    function setupObserver() {
        if (!document.body) return; // Final safety check

        const observer = new MutationObserver((mutations) => {
            // If the swiper class appears or changes, re-run the fix
            if (document.querySelector('.swiper-initialized')) {
                fixSwiper();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('resize', fixSwiper);
})();


// product dots

document.addEventListener("DOMContentLoaded", function() {
    const slider = document.querySelector('.product-gallery.product-gallery--slider.lap--grid--slider-container .css-slider.css-slider--bottom-navigation');
    const thumbHolder = document.querySelector('.product-gallery__thumbnails-holder');
    
    if (slider && thumbHolder) {
        const thumbnails = thumbHolder.querySelectorAll('.thumbnail');
        
        // 1. Create the container for dots
        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'custom-gallery-dots';
        
        // 2. Create a dot for each thumbnail
        thumbnails.forEach((thumb, index) => {
            const dot = document.createElement('span');
            dot.className = 'gallery-dot';
            if (thumb.classList.contains('active')) {
                dot.classList.add('active');
            }
            
            dot.addEventListener('click', () => thumb.click());
            dotsContainer.appendChild(dot);
        });

        // 3. Append to the slider container
        slider.appendChild(dotsContainer);

        // 4. Update dots when a thumbnail state changes
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const allThumbs = Array.from(thumbnails);
                    const activeIndex = allThumbs.findIndex(t => t.classList.contains('active'));
                    const allDots = dotsContainer.querySelectorAll('.gallery-dot');
                    
                    allDots.forEach(d => d.classList.remove('active'));
                    if (allDots[activeIndex]) {
                        allDots[activeIndex].classList.add('active');
                    }
                }
            });
        });

        // Observe each thumbnail for class changes (active state)
        thumbnails.forEach(thumb => observer.observe(thumb, { attributes: true }));
    }
});


document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Define the selectors based on your inspect code
  const mainInputSelector = '.product-quantity .qty-selector';
  const stickyInputSelector = 'input[id^="StickyQuantity-"]';

  const syncAll = (newValue) => {
    const allInputs = document.querySelectorAll(`${mainInputSelector}, ${stickyInputSelector}`);
    allInputs.forEach(input => {
      if (input.value !== newValue) {
        input.value = newValue;
        // Trigger events so the theme knows the value changed
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  // 2. Listen for clicks on ALL plus/minus buttons (Main AND Sticky)
  document.addEventListener('click', function(e) {
    // Check if it's a theme button (.qty-button) or our sticky button (.qty-btn)
    const btn = e.target.closest('.qty-button, .qty-btn');
    if (!btn) return;

    // Small delay to let the theme's own script finish updating the number first
    setTimeout(() => {
      const parentContainer = btn.closest('product-quantity, .sticky-add-to-cart__quantity');
      if (parentContainer) {
        const input = parentContainer.querySelector('input[type="number"]');
        if (input) syncAll(input.value);
      }
    }, 50); 
  });

  // 3. Listen for manual typing in any quantity box
  document.addEventListener('input', function(e) {
    if (e.target.matches(`${mainInputSelector}, ${stickyInputSelector}`)) {
      syncAll(e.target.value);
    }
  });
});



// ifream 

// function syncVideoHeight() {
//   const videoWrappers = document.querySelectorAll('.vimeo-video-wrapper');
//   console.log(videoWrappers);

//   videoWrappers.forEach(wrapper => {
//     const height = wrapper.offsetHeight;

//     document.querySelectorAll('.element--height-auto').forEach(el => {
//       el.style.height = height + 'px';
//     });
//   });
// }

// window.addEventListener('load', syncVideoHeight);
// window.addEventListener('resize', syncVideoHeight);

// theme file js 
// (function() {

//         function syncVideoHeight() {
//           const videoWrappers = document.querySelectorAll('.vimeo-video-wrapper');

//           videoWrappers.forEach(wrapper => {
//             const height = wrapper.offsetHeight;

//             document.querySelectorAll('.element--height-auto').forEach(el => {
//               el.style.height = height + 'px';
//             });
//           });
//         }

//         document.addEventListener('DOMContentLoaded', syncVideoHeight);
//         window.addEventListener('resize', syncVideoHeight);
//         document.addEventListener('shopify:section:load', syncVideoHeight);

//       })();

document.querySelectorAll('.vimeo-iframe').forEach(function(iframe){
  iframe.addEventListener('load', function(){

    iframe.style.opacity = 1;

    const placeholder = iframe.parentElement.querySelector('.vimeo-placeholder');
    if(placeholder){
      placeholder.style.display = 'none';
    }

  });
});

// document.addEventListener("click", function(e){

//   const btn = e.target.closest(".comparison-btn");
//   if(!btn) return;

//   e.preventDefault();

//   const variantId = btn.dataset.variant;
//   if(!variantId) return;

//   const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
//   const realATC = document.querySelector("[data-js-atc]");

//   if(!variantInput || !realATC) return;

//   /* store original variant */
//   const originalVariant = variantInput.value;

//   /* temporarily switch variant */
//   variantInput.value = variantId;

//   /* trigger real add to cart */
//   realATC.click();

//   /* restore original variant after add */
//   setTimeout(function(){
//     variantInput.value = originalVariant;
//   }, 300);

// });


document.addEventListener("click", function(e){

  const btn = e.target.closest(".comparison-btn");
  if(!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variant;
  if(!variantId) return;

  const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  const qtyInput = document.querySelector('[data-js-atc-qty]');
  const realATC = document.querySelector("[data-js-atc]");

  if(!variantInput || !realATC) return;

  /* store original values */
  const originalVariant = variantInput.value;
  const originalQty = qtyInput ? qtyInput.value : 1;

  /* temporarily switch variant + qty */
  variantInput.value = variantId;

  if(qtyInput){
    qtyInput.value = 1;
  }

  /* trigger real add to cart */
  realATC.click();

  /* restore original values */
  setTimeout(function(){
    variantInput.value = originalVariant;

    if(qtyInput){
      qtyInput.value = originalQty;
    }
  }, 300);

});


// (function () {

//   function syncVideoHeight() {

//     const slide = document.querySelector('.main-slide-one');
//     const videoWrapper = document.querySelector('.main-slide-one .vimeo-video-wrapper');

//     if (!slide || !videoWrapper) return;

//     const height = slide.offsetHeight;

//     videoWrapper.style.height = height + 'px';
//     videoWrapper.style.paddingTop = '0'; // override 56.25%
//   }

//   document.addEventListener('DOMContentLoaded', syncVideoHeight);
//   window.addEventListener('resize', syncVideoHeight);

// })();
 
document.addEventListener("DOMContentLoaded", function(){

  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  document.head.appendChild(tag);

  window.onYouTubeIframeAPIReady = function(){

    document.querySelectorAll(".youtube-video-iframe").forEach(function(iframe){

      const wrapper = iframe.closest(".youtube-video-wrapper");

      const player = new YT.Player(iframe, {

        events: {

          onReady: function(event){

            const p = event.target;

            p.mute();

            /* Request higher quality */
            p.setPlaybackQuality('hd1080'); 
            // use 'hd1080' if the video supports 1080
            // use 'hd2160' if the video supports 4K

            p.playVideo();

            /* Prevent reaching the real end of video */
            setInterval(function(){

              const duration = p.getDuration();
              const current = p.getCurrentTime();

              if(duration && current > duration - 0.4){
                p.seekTo(0);
              }

            }, 200);

          },

          onStateChange: function(event){

            if(event.data === YT.PlayerState.PLAYING){
              wrapper.classList.add("video-loaded");
            }

          }

        }

      });

    });

  };

});